export const PATH = {
  ACCOUNT: '/account',
  HISTORY: '/history',
  CARTS: '/carts',
  INVOICES: '/invoices',
  RECEIVING: '/receiving',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  MY_FILES: '/myfiles',
  MY_VENDORS: '/myvendors',
  CREDITS: '/credits',
  TOS: '/tos',
  CONTACT_US: '/new-message',
  REPORT_AR: '/report-ar',
  DAILY_REPORT: '/dailyreport',
  DAILY_REPORTS: '/dailyreports',
  MESSAGE: '/message',
  MESSAGES: '/messages',
  NEW_MESSAGE: '/new-message',
  BROADCASTS: '/broadcasts',
};

export default PATH;
